import { Environment } from '../../config/environment';
import { Backend } from '../Backend';
import { IFavoriteElementV1, IRibbon2Container } from '../models/AndromeTV.types';
import { FavoriteFilter, FavoriteID, FavoriteRibbonFilter } from './FavoriteApi.types';

export class FavoriteApi {
  /**
   * Retrieve the favorite with the specified type and id
   */
  static favorite(backend: Backend, favoriteId: FavoriteID): Promise<IFavoriteElementV1> {
    const type = encodeURIComponent(favoriteId.type);
    const id = encodeURIComponent(favoriteId.id);
    const url = backend.makeUrl(`history/v1/favorite/${type}/${id}`, {
      profileId: backend.deviceProfile?.id,
    });
    return backend.getJson(url, backend.bearer) as Promise<IFavoriteElementV1>;
  }

  /**
   * Create or update a favorite
   */
  static update(backend: Backend, favoriteId: FavoriteID): Promise<unknown> {
    const type = encodeURIComponent(favoriteId.type);
    const id = encodeURIComponent(favoriteId.id);
    const url = backend.makeUrl(`history/v1/favorite/${type}/${id}`, {
      profileId: backend.deviceProfile?.id,
    });
    return backend.putJson(url, {}, backend.bearer);
  }

  /**
   * Remove a favorite
   */
  static delete(backend: Backend, favoriteId: FavoriteID): Promise<unknown> {
    const type = encodeURIComponent(favoriteId.type);
    const id = encodeURIComponent(favoriteId.id);
    const url = backend.makeUrl(`history/v1/favorite/${type}/${id}`, {
      profileId: backend.deviceProfile?.id,
    });
    return backend.delete(url, backend.bearer);
  }

  /**
   * Retrieve a list of favorites
   */
  static list(backend: Backend, filter: FavoriteFilter): Promise<IFavoriteElementV1[]> {
    const url = backend.makeUrl('history/v1/favorite', filter);
    return backend.getJson(url, backend.bearer) as Promise<IFavoriteElementV1[]>;
  }

  /**
   * Retrieve a list of favorites in CMS Ribbon format
   */
  static ribbon(backend: Backend, filter: FavoriteRibbonFilter): Promise<IRibbon2Container> {
    const queryParam = {
      platform: Environment.system,
      ...filter,
    };
    const url = backend.makeUrl('history/v2/cms/favorite', queryParam);
    return backend.getJson(url, backend.bearer) as Promise<IRibbon2Container>;
  }
}
